export default {
  Request: 1, // Giấy đề nghị nhập kho
  Order: 2,   // Lệnh nhập kho
};
